import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwUpdate } from '@angular/service-worker';

import { WebsocketService } from '../../Services/websocket.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-help-buttons',
  imports: [CommonModule],
  templateUrl: './help-buttons.component.html',
  styleUrl: './help-buttons.component.css'
})
export class HelpButtonsComponent {

  constructor(
    private websocketService: WebsocketService,
    private swUpdate: SwUpdate
  ) { 
    if (swUpdate.isEnabled) {
      console.log("Atualização automática ativa.");
      swUpdate.versionUpdates.subscribe(event => {
        switch (event.type) {
          case 'VERSION_DETECTED':
            console.log(`Nova versão: ${event.version.hash}`);
            break;
          case 'VERSION_READY':
            console.log(`Versão atual: ${event.currentVersion.hash}`);
            console.log(`Versão disponível: ${event.latestVersion.hash}`);
            // Prompt user to update
            if (confirm('Existe uma nova versão. Atualizar?')) {
              swUpdate.activateUpdate().then(() => document.location.reload());
            }
            break;
          case 'VERSION_INSTALLATION_FAILED':
            console.error('Erro ao instalar nova versão:', event.error);
            break;
        }
      });
    }
  }

  title = 'buttons';
  version: any = environment.version
  numberOfButtons: number = environment.numberOfButtons
  private mins: number = environment.alertTimeMin
  private secs: number = 0

  private clockButton: boolean = environment.clockButton

  year: any
  private current:Date= new Date()
  pHour:any
  private fHour: any
  buttonClass: any = []
  buttonIcoClass: any = []
  timerMin:any = []
  timerSec:any = []
  private intervalId: any
  private randN: any
  private alertInterval: any = []
  rightSection: any = 'right-section hidden'
  rightSectionVisible: boolean= false
  textButton: any = []
  logsText: any = ''
  private buttonReceived: any
  statusText: any
  private Timeout: any

  private idToNumberMap: Record<any, string> = {
    "E663AC91D3656232": "1",
    "E663B035971F9723": "2",
    "E6614103E74E7E37": "3",
    "E6647C15677B2430": "4",
    "\"E663AC91D3656232\"": "1",
    "\"E663B035971F9723\"": "2",
    "\"E6614103E74E7E37\"": "3",
    "\"E6647C15677B2430\"": "4",
  };

  private notifications: Array<Notification> = [];

  public checkingForUpdates: boolean = false;
  public buttonText = 'Verificar atualizações'

  ngOnInit(){
    Notification.requestPermission();
    this.updateButtons();
    this.currentTime();
    this.receiveSocketResponse()
    this.logsText += this.fHour + ': Início' + '\n'

    setInterval(() => {
      this.currentTime();
    },1000);
    
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.returnValue = 'Ao sair, irá perder as notificações.';
    return event.returnValue; 
  }

  private receiveSocketResponse() {

    this.websocketService.reciveMessage().subscribe(
    (message) => {
      const value = this.idToNumberMap[message];

      message = value ? Number(value)  : message;
      
      if(!isNaN(message) && message > 0 && message <= this.numberOfButtons){
        this.buttonReceived = message
        this.recivedMessageAlert()
      } else {
        try {
          let msg = JSON.parse(message)

          if(msg['cancel_button'] != undefined && msg['cancel_button'] <= this.numberOfButtons){
            this.cancelAlert(msg['cancel_button'], true)
          } else {
            console.warn("unkonw operation")
          }
        } catch (error) {
          console.warn("invalid message format")
        } 
      } 

      window.clearTimeout(this.Timeout)
      this.statusText = 'Conexão estabelecida, aguardando eventos!';
      this.Timeout = setInterval(() => {
        this.statusText = 'Conexão perdida!...Tentando reconectar';
      },16000);
    },
    (error) => {
      this.receiveSocketResponse()
    }
  );

   }

  private recivedMessageAlert(){

    let button = this.translateButtonText(this.buttonReceived.toString());
    let buttonNum = this.buttonReceived;
    let time = this.pHour

    this.logsText += this.fHour + ': ' + button +' - pressionado.' + '\n'
    if(this.buttonClass[buttonNum] != 'ballAlert'){
      this.notifications[buttonNum] = new Notification("Botão pressionado", { body: button + ' - pressionado às ' + time + '!', icon:'assets/img/alert_icon.png'})
      this.playAudioNotification();
      
      this.alertInterval[buttonNum] = setInterval(() => {
        this.notifications[buttonNum] = new Notification("Botão pressionado", { body: button + ' - pressionado às ' + time + ' sem resposta!', icon:'assets/img/alert_icon.png'})
        this.playAudioNotification();
      }, 15000);
      
      setTimeout(() => {
          this.notifications[buttonNum].close()
      }, 3000)

      this.buttonClass[buttonNum] = 'ballAlert'
      this.buttonIcoClass[buttonNum] = 'ball-iconAlert'
      window.clearInterval(this.intervalId)
      this.timerMin[buttonNum] = this.mins
      this.timerSec[buttonNum] = this.secs
      this.createInterval()
    }
  }

  translateButtonText(n: string){
    return environment.buttonsNames[parseInt(n)-1]
  }

  translateButtonIdentifier(n: string){
    return environment.buttonsIdentifiers[parseInt(n)-1]
  }

  private currentTime() {
    this.current = new Date()
    this.year = new Date().getFullYear();
    const MHour: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    };
    const FHour: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hour12: false
    };
    this.pHour = this.current.toLocaleTimeString(undefined, MHour);
    this.fHour = this.current.toLocaleTimeString(undefined, FHour);
  }

  numSequence(n: number): Array<number> {
    let arr = Array.from({length: n}, (_,i)=>  i+1)

    return arr;
  }

  private updateButtons(){
    for (var i: number = 1; i <= this.numberOfButtons; i++) {
      this.buttonIcoClass[i] = 'ball-icon'
      this.buttonClass[i] = 'ball'
      this.textButton[i]=''
      this.timerSec[i] = 0
      this.timerMin[i] = 0
    }
  }

  cancelAlert(n: any, ext: boolean = false){
    if(this.buttonClass[n]=='ballAlert'){
      window.clearInterval(this.alertInterval[n])
      this.notifications[n].close()
      if(!ext) this.sendCancel(n);
      this.buttonClass[n] = 'ball'
      this.buttonIcoClass[n] = 'ball-icon'
      this.timerMin[n] = 0
      this.timerSec[n] = 0
      this.textButton[n]='Cancelado'
      let txtCancelado = ext ? ' - cancelado (ext).' : ' - cancelado.'
      this.logsText += this.fHour + ': ' + this.translateButtonText(n.toString()) + txtCancelado + '\n'
      setTimeout(() => {
        this.textButton[n]=''
      }, 3000);
    }
  }

  private createInterval(){
    this.intervalId= setInterval(() => {
      for (var i: number = 1; i <= this.numberOfButtons; i++) {
        if(this.buttonClass[i] == 'ballAlert')
          if (this.timerSec[i]- 1 == -1) {
            this.timerMin[i] -= 1;
            this.timerSec[i] = 59
            this.textButton[i]= undefined
          } 
      else this.timerSec[i] -= 1

      if (this.timerMin[i] == 0 && this.timerSec[i] == 0){
        if(this.alertInterval[i]) window.clearInterval(this.alertInterval[i])

        if(this.textButton[i] == undefined){
          this.textButton[i] = 'Fim'
        }}
        if(this.textButton[i] == 'Fim' && this.buttonClass[i] == 'ballAlert'){
          this.buttonClass[i] = 'ball'
          this.logsText += this.fHour + ': ' + this.translateButtonText(i.toString()) +' - Fim de tempo.' + '\n'
          this.buttonIcoClass[i] = 'ball-icon'
        }
        if(this.textButton[i] == 'Fim'){
          var n= i
            setTimeout(() => {
              this.textButton[n] = ''
            }, 2000);
        }
          
      }
    }, 1000)
  }

  randomAlert(){

    if(this.clockButton == false){
      return;
    }

    this.randN = Math.floor(Math.random() * this.numberOfButtons)+1

    this.websocketService.sendMessage(environment.buttonsIdentifiers[this.randN -1])
  }

  sendCancel(number: number = 1){
    let msg = {
      cancel_button: number
    }
    this.websocketService.sendMessage(msg)

  }

  rightSectionONOFF(){
    if(this.rightSection == 'right-section'){
      this.rightSection = 'right-section hidden';
      this.rightSectionVisible = false;
    }else{
      this.rightSection = 'right-section';
      this.rightSectionVisible = true;

    }
  }
  
  eraseLogs(){
    this.logsText='';
    this.logsText += this.fHour + ': Início' + '\n'
  }

  private playAudioNotification(){
    let audio = new Audio();
    audio.src = "assets/sounds/alarm.wav";
    audio.load();
    audio.play();
  }

  private disconnectSocket() {
    this.websocketService.closeConnection();
  }

  ngOnDestroy() {
    this.disconnectSocket();
    for (var i: number = 1; i <= this.numberOfButtons; i++) {
      if(this.alertInterval[i]) window.clearInterval(this.alertInterval[i])
        this.notifications[i].close()
    }
  }

  checkForUpdates() {
    if (!this.swUpdate.isEnabled) {
      this.buttonText = 'Atualizações não suportadas';
      this.resetButtonAfterDelay();
      return;
    }

    this.checkingForUpdates = true;
    this.buttonText = 'A verificar atualizações...';

    this.swUpdate.checkForUpdate()
      .then(() => {
        console.log('Update check complete.');
        // If no update found, SwUpdate emits nothing — so we manually reset
        this.buttonText = 'Não existem atualizações';
        this.resetButtonAfterDelay();
      })
      .catch(err => {
        console.error('Error checking for updates:', err);
        this.buttonText = 'Erro ao verificar atualizações';
        this.resetButtonAfterDelay();
      });

    this.resetButtonAfterDelay();
  }

  private resetButtonAfterDelay() {
    setTimeout(() => {
      this.buttonText = 'Não existem atualizações';
    }, 1500);
    setTimeout(() => {
      this.buttonText = 'Verificar atualizações';
      this.checkingForUpdates = false;
    }, 3000);
  }
}
